import React, { useEffect, useMemo, useRef, useState } from 'react';

function CountUpText({ value, duration = 1400, formatter }) {
  const target = useMemo(() => Number(value || 0), [value]);
  const [displayValue, setDisplayValue] = useState(0);
  const hasAnimatedRef = useRef(false);

  useEffect(() => {
    if (hasAnimatedRef.current) {
      setDisplayValue(target);
      return;
    }

    let animationFrame;
    let startTime = null;

    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;

      const progress = Math.min((timestamp - startTime) / duration, 1);
      const currentValue = target * progress;

      setDisplayValue(currentValue);

      if (progress < 1) {
        animationFrame = requestAnimationFrame(animate);
      } else {
        hasAnimatedRef.current = true;
      }
    };

    animationFrame = requestAnimationFrame(animate);

    return () => cancelAnimationFrame(animationFrame);
  }, [target, duration]);

  return formatter ? formatter(displayValue) : displayValue.toFixed(2);
}

export default CountUpText;
